export interface Show {
  id: string;
  title: string;
  description: string;
  category: string;
  image: string;
  date: string;
  views: string;
  duration: string;
  tags: string[];
  rating: number;
  fullContent: string;
  host: string;
  guests: string[];
  episodes: number;
  platform: string;
  updateDay: string;
}

export interface Category {
  slug: string;
  name: string;
  icon: string;
  description: string;
}

export const categories: Category[] = [
  { slug: 'all', name: '全部综艺', icon: 'ri-play-list-2-line', description: '浏览全部综艺节目，发现你的最爱' },
  { slug: 'reality', name: '真人秀', icon: 'ri-camera-line', description: '真实记录，精彩呈现，最热真人秀综艺' },
  { slug: 'talkshow', name: '脱口秀', icon: 'ri-chat-smile-2-line', description: '幽默搞笑，妙语连珠，热门脱口秀节目' },
  { slug: 'music', name: '音乐综艺', icon: 'ri-music-2-line', description: '天籁之音，音乐盛宴，热门音乐综艺' },
  { slug: 'competition', name: '竞技综艺', icon: 'ri-trophy-line', description: '热血对决，巅峰较量，精彩竞技综艺' },
  { slug: 'comedy', name: '搞笑综艺', icon: 'ri-emotion-laugh-line', description: '爆笑不断，欢乐无限，热门搞笑综艺' },
  { slug: 'lifestyle', name: '生活综艺', icon: 'ri-home-heart-line', description: '生活方式，美好日常，温馨生活综艺' },
  { slug: 'talent', name: '选秀节目', icon: 'ri-star-line', description: '梦想起航，星光闪耀，精彩选秀节目' },
];

export const shows: Show[] = [
  {
    id: 'show-1',
    title: '奔跑吧·兄弟 第十二季',
    description: '全新一季《奔跑吧》热血回归！李晨、郑恺、Angelababy携新成员带来更刺激的游戏挑战与爆笑互动，每一期都是全新的冒险。',
    category: 'reality',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20variety%20show%20Running%20Man%20style%20outdoor%20game%20challenge%20energetic%20group%20of%20celebrities%20running%20in%20colorful%20sportswear%20bright%20sunny%20day%20dynamic%20action%20scene%20professional%20photography%20warm%20tones&width=800&height=450&seq=show-01&orientation=landscape',
    date: '2026-07-28',
    views: '2.3亿',
    duration: '90分钟',
    tags: ['真人秀', '户外竞技', '热门'],
    rating: 9.2,
    fullContent: '<h2>节目简介</h2><p>《奔跑吧·兄弟》是中国最具影响力的户外竞技真人秀节目之一。第十二季延续了经典的跑男精神，由李晨、郑恺、Angelababy领衔，搭配全新加盟的年轻艺人，为观众带来更加精彩纷呈的节目内容。</p><h2>节目亮点</h2><p>本季节目在游戏设计上更加大胆创新，融合了科技元素与传统文化，既有紧张刺激的对抗环节，也有温馨感人的团队合作。每一期都会在不同的城市取景，展现中国各地的风土人情。</p><h2>播出信息</h2><p>每周五晚20:00在各大平台同步更新，每期时长约90分钟。同时提供会员抢先看服务，会员可以提前24小时观看最新一期。</p>',
    host: '李晨',
    guests: ['郑恺', 'Angelababy', '沙溢', '白鹿', '周深'],
    episodes: 12,
    platform: '多平台联播',
    updateDay: '每周五',
  },
  {
    id: 'show-2',
    title: '脱口秀大会 第六季',
    description: '李诞领衔，笑果文化倾力打造！全新脱口秀演员登台，爆笑段子层出不穷，用幽默解读生活，让你笑到停不下来。',
    category: 'talkshow',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20standup%20comedy%20show%20stage%20with%20spotlight%20comedian%20holding%20microphone%20on%20stage%20modern%20theater%20warm%20lighting%20audience%20laughing%20professional%20photography%20clean%20composition&width=800&height=450&seq=show-02&orientation=landscape',
    date: '2026-07-25',
    views: '1.8亿',
    duration: '60分钟',
    tags: ['脱口秀', '搞笑', '语言类'],
    rating: 9.0,
    fullContent: '<h2>节目简介</h2><p>《脱口秀大会》是由笑果文化出品的喜剧脱口秀竞演节目。第六季在赛制上做了全新升级，引入更多元的表演形式和更激烈的晋级机制。</p><h2>节目亮点</h2><p>本季邀请了更多跨界嘉宾参与，包括演员、歌手、作家等不同领域的艺人，他们用自己独特的视角和幽默感为观众带来全新的脱口秀体验。</p><h2>播出信息</h2><p>每周三、周六晚20:00更新，每期约60分钟。VIP会员可享受完整版和幕后花絮。</p>',
    host: '李诞',
    guests: ['王建国', '庞博', '杨笠', '呼兰', '何广智'],
    episodes: 10,
    platform: '网络平台首播',
    updateDay: '每周三、六',
  },
  {
    id: 'show-3',
    title: '中国好声音 2026',
    description: '全新导师阵容震撼来袭！四位华语乐坛顶级歌手坐镇导师席，寻找最动听的声音，用音乐点燃整个夏天。',
    category: 'music',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20singing%20competition%20show%20stage%20with%20four%20red%20chairs%20facing%20away%20singer%20on%20stage%20dramatic%20lighting%20concert%20atmosphere%20professional%20photography%20warm%20spotlight&width=800&height=450&seq=show-03&orientation=landscape',
    date: '2026-07-20',
    views: '3.1亿',
    duration: '100分钟',
    tags: ['音乐', '选秀', '热门'],
    rating: 9.5,
    fullContent: '<h2>节目简介</h2><p>《中国好声音》是中国最具影响力的音乐选秀节目。2026年全新赛季，四位重量级导师加盟，他们将从全国各地海选中脱颖而出的选手中，寻找真正的好声音。</p><h2>节目亮点</h2><p>本季在盲选环节加入了新的互动机制，导师之间的抢人大战更加精彩。同时，节目组还特别设置了原创歌曲赛道，鼓励选手展示创作才华。</p><h2>播出信息</h2><p>每周五晚21:00播出，每期约100分钟。提供高清无损音质版本，让观众享受极致音乐体验。</p>',
    host: '华少',
    guests: ['周杰伦', '李荣浩', '邓紫棋', '薛之谦'],
    episodes: 15,
    platform: '全国卫视+网络平台',
    updateDay: '每周五',
  },
  {
    id: 'show-4',
    title: '向往的生活 第八季',
    description: '黄磊、何炅带你回归田园，在蘑菇屋享受慢生活。新一季探索更多美丽村落，品美食、聊人生、治愈心灵。',
    category: 'lifestyle',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20slow%20life%20variety%20show%20countryside%20cottage%20with%20garden%20celebrities%20cooking%20outdoor%20kitchen%20green%20fields%20mountains%20background%20warm%20afternoon%20light%20peaceful%20atmosphere%20professional%20photography&width=800&height=450&seq=show-04&orientation=landscape',
    date: '2026-07-18',
    views: '2.6亿',
    duration: '80分钟',
    tags: ['生活', '慢综艺', '美食'],
    rating: 9.3,
    fullContent: '<h2>节目简介</h2><p>《向往的生活》是一档大型生活服务纪实节目。第八季黄磊与何炅继续带领观众走进中国最美的乡村，体验自给自足的田园生活。</p><h2>节目亮点</h2><p>本季蘑菇屋选址于云南大理的苍山脚下，依山傍水，风景如画。每期邀请不同领域的嘉宾来做客，一起劳作、做饭、聊天，展现最真实的生活状态。</p><h2>播出信息</h2><p>每周日晚22:00播出，每期约80分钟。VIP会员可以观看未删减完整版及独家幕后花絮。</p>',
    host: '黄磊',
    guests: ['何炅', '张艺兴', '彭昱畅', '张子枫'],
    episodes: 14,
    platform: '网络平台首播',
    updateDay: '每周日',
  },
  {
    id: 'show-5',
    title: '极限挑战 第十季',
    description: '男人帮重组归来！黄渤、孙红雷、黄磊、张艺兴再度合体，全新赛制、疯狂挑战，极限精神永不落幕。',
    category: 'competition',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20extreme%20challenge%20variety%20show%20group%20of%20male%20celebrities%20in%20urban%20city%20action%20pose%20dynamic%20competition%20colorful%20modern%20cityscape%20background%20professional%20photography%20dramatic%20lighting&width=800&height=450&seq=show-05&orientation=landscape',
    date: '2026-07-15',
    views: '2.8亿',
    duration: '95分钟',
    tags: ['竞技', '挑战', '热门'],
    rating: 9.4,
    fullContent: '<h2>节目简介</h2><p>《极限挑战》是一档大型励志体验真人秀节目。第十季"男人帮"经典阵容回归，在全新升级的挑战任务中展现智慧、勇气与团队精神。</p><h2>节目亮点</h2><p>本季挑战横跨中国多个城市，从冰天雪地的哈尔滨到热带风情的三亚，每期都有令人意想不到的任务设计。全新加入的AI互动元素让节目更具未来感和观赏性。</p><h2>播出信息</h2><p>每周日晚21:00东方卫视首播，网络平台同步更新。会员专享导演剪辑版。</p>',
    host: '黄渤',
    guests: ['孙红雷', '黄磊', '张艺兴', '王迅', '迪丽热巴'],
    episodes: 12,
    platform: '东方卫视+网络平台',
    updateDay: '每周日',
  },
  {
    id: 'show-6',
    title: '王牌对王牌 第九季',
    description: '沈腾、贾玲两大喜剧巨星坐镇，华晨宇、关晓彤活力加盟，经典游戏全新升级，笑料百出精彩不断。',
    category: 'comedy',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20comedy%20game%20variety%20show%20studio%20set%20with%20colorful%20decorations%20celebrities%20playing%20funny%20games%20laughing%20together%20bright%20stage%20lighting%20entertaining%20atmosphere%20professional%20photography&width=800&height=450&seq=show-06&orientation=landscape',
    date: '2026-07-12',
    views: '2.5亿',
    duration: '85分钟',
    tags: ['搞笑', '游戏', '热门'],
    rating: 9.1,
    fullContent: '<h2>节目简介</h2><p>《王牌对王牌》是一档大型室内游戏竞技综艺节目。第九季由沈腾和贾玲领衔的王牌家族再度集结，带来更加爆笑的室内游戏对决。</p><h2>节目亮点</h2><p>本季游戏环节全面升级，新增"演技大考验"、"即兴喜剧"等创新环节。每期邀请热门影视剧组或经典IP团队作为嘉宾，展开精彩对决。</p><h2>播出信息</h2><p>每周五晚20:20浙江卫视播出，网络平台同步更新。</p>',
    host: '沈涛',
    guests: ['沈腾', '贾玲', '华晨宇', '关晓彤'],
    episodes: 12,
    platform: '浙江卫视+网络平台',
    updateDay: '每周五',
  },
  {
    id: 'show-7',
    title: '创造营2026',
    description: '全新一季创造营重磅开启！百位练习生追逐偶像梦想，残酷淘汰赛制，见证下一个超级偶像的诞生。',
    category: 'talent',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20idol%20survival%20show%20large%20stage%20with%20many%20young%20trainees%20performing%20dance%20in%20matching%20outfits%20dramatic%20stage%20lighting%20pyramid%20seats%20professional%20photography%20energetic&width=800&height=450&seq=show-07&orientation=landscape',
    date: '2026-07-10',
    views: '4.2亿',
    duration: '120分钟',
    tags: ['选秀', '偶像', '热门'],
    rating: 9.6,
    fullContent: '<h2>节目简介</h2><p>《创造营2026》是腾讯视频出品的偶像女团/男团竞演养成类真人秀。本季汇集了来自全球华人地区的100位练习生，他们将在三个月的封闭训练中争夺最终的出道名额。</p><h2>节目亮点</h2><p>本季导师阵容空前强大，涵盖舞蹈、声乐、说唱、表演等多个领域。赛制上首次引入国际交流环节，练习生将有机会与海外知名偶像团体合作表演。</p><h2>播出信息</h2><p>每周六晚19:00更新，每期约120分钟。会员享有额外投票权和独家幕后内容。</p>',
    host: '何炅',
    guests: ['王一博', 'Lisa', '张艺兴', '邓紫棋'],
    episodes: 12,
    platform: '网络平台独家',
    updateDay: '每周六',
  },
  {
    id: 'show-8',
    title: '一年一度喜剧大赛 第三季',
    description: '马东携全新喜剧阵容回归！sketch、漫才、默剧、即兴喜剧百花齐放，让你见识喜剧的无限可能。',
    category: 'comedy',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20comedy%20sketch%20show%20theater%20stage%20actors%20in%20colorful%20costumes%20performing%20funny%20skit%20dramatic%20expressions%20bright%20stage%20lighting%20professional%20photography%20creative%20set%20design&width=800&height=450&seq=show-08&orientation=landscape',
    date: '2026-07-08',
    views: '1.5亿',
    duration: '75分钟',
    tags: ['喜剧', '搞笑', '竞技'],
    rating: 9.0,
    fullContent: '<h2>节目简介</h2><p>《一年一度喜剧大赛》是由米未传媒出品的喜剧竞演节目。第三季延续了"好笑是最高的标准"这一核心理念，汇集了全国最优秀的喜剧创作者。</p><h2>节目亮点</h2><p>本季作品类型更加丰富，从社会热点到日常生活，从荒诞喜剧到温情小品，用多元化的喜剧形式展现当代中国人的精神状态。</p><h2>播出信息</h2><p>每周五晚20:00更新，每期约75分钟。VIP会员可观看完整未删减版。</p>',
    host: '马东',
    guests: ['黄渤', '徐峥', '于和伟', '李诞'],
    episodes: 10,
    platform: '网络平台首播',
    updateDay: '每周五',
  },
  {
    id: 'show-9',
    title: '歌手·当打之年 2026',
    description: '华语乐坛顶级歌手同台竞技，殿堂级音乐人的巅峰对决。每期一首经典，用声音征服舞台，创造传奇现场。',
    category: 'music',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20professional%20singing%20competition%20grand%20stage%20with%20orchestra%20singer%20in%20elegant%20gown%20holding%20microphone%20dramatic%20spotlight%20concert%20hall%20atmosphere%20professional%20photography%20luxurious&width=800&height=450&seq=show-09&orientation=landscape',
    date: '2026-07-05',
    views: '3.5亿',
    duration: '110分钟',
    tags: ['音乐', '竞技', '顶级'],
    rating: 9.7,
    fullContent: '<h2>节目简介</h2><p>《歌手·当打之年》是湖南卫视推出的顶级音乐竞技节目。2026赛季汇聚了华语乐坛最具实力的歌手，他们将用最纯粹的歌声征服舞台和观众。</p><h2>节目亮点</h2><p>本季特邀国际顶级音乐人作为帮唱嘉宾，每期还设置了经典歌曲改编环节，歌手们将用自己的风格重新演绎华语乐坛的经典作品。</p><h2>播出信息</h2><p>每周五晚20:10湖南卫视直播，提供无损音质版本。网络平台同步更新回放。</p>',
    host: '何炅',
    guests: ['林俊杰', '邓紫棋', '华晨宇', '周深', '袁娅维'],
    episodes: 13,
    platform: '湖南卫视+网络平台',
    updateDay: '每周五',
  },
  {
    id: 'show-10',
    title: '哈哈哈哈哈 第四季',
    description: '邓超、陈赫、鹿晗三兄弟公路旅行继续！无剧本、无套路，最真实的旅途故事，最爆笑的兄弟情谊。',
    category: 'reality',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20road%20trip%20variety%20show%20three%20male%20celebrities%20laughing%20in%20a%20car%20traveling%20on%20scenic%20highway%20beautiful%20mountain%20landscape%20sunny%20day%20casual%20style%20professional%20photography%20warm%20tones&width=800&height=450&seq=show-10&orientation=landscape',
    date: '2026-07-02',
    views: '2.1亿',
    duration: '70分钟',
    tags: ['真人秀', '旅行', '搞笑'],
    rating: 9.1,
    fullContent: '<h2>节目简介</h2><p>《哈哈哈哈哈》是一档公路旅行真人秀节目。第四季中邓超、陈赫、鹿晗三兄弟再次踏上未知旅途，没有剧本、没有限制，展现明星最真实的一面。</p><h2>节目亮点</h2><p>本季路线横跨中国西部，从四川成都出发，一路向西穿越青藏高原，展现壮美的自然风光和沿途的风土人情。三兄弟在旅途中遇到的各种意外和趣事，让节目充满惊喜。</p><h2>播出信息</h2><p>每周三晚20:00更新，每期约70分钟。</p>',
    host: '邓超',
    guests: ['陈赫', '鹿晗'],
    episodes: 10,
    platform: '网络平台首播',
    updateDay: '每周三',
  },
  {
    id: 'show-11',
    title: '令人心动的offer 第六季',
    description: '顶级律所实习争夺战再度开启！八位法学精英为梦想拼搏，真实职场挑战，看谁能拿下心动的Offer。',
    category: 'lifestyle',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20career%20observation%20variety%20show%20modern%20law%20office%20young%20professionals%20in%20formal%20wear%20working%20at%20desks%20high-end%20office%20interior%20glass%20walls%20professional%20atmosphere%20bright%20lighting&width=800&height=450&seq=show-11&orientation=landscape',
    date: '2026-06-28',
    views: '1.3亿',
    duration: '65分钟',
    tags: ['职场', '真人秀', '律政'],
    rating: 8.9,
    fullContent: '<h2>节目简介</h2><p>《令人心动的offer》是一档职场观察类真人秀。第六季聚焦律师行业，八位来自顶尖法学院的实习生将在顶级律所进行为期一个月的实习竞争。</p><h2>节目亮点</h2><p>本季引入了更多实战案例，实习生需要处理真实的法律案件，包括商业诉讼、知识产权、刑事辩护等多个领域。观察室嘉宾阵容升级，从多维度解读职场生存法则。</p><h2>播出信息</h2><p>每周二、周四晚20:00更新，每期约65分钟。</p>',
    host: '何炅',
    guests: ['撒贝宁', '杨天真', '周深'],
    episodes: 10,
    platform: '网络平台首播',
    updateDay: '每周二、四',
  },
  {
    id: 'show-12',
    title: '蒙面唱将猜猜猜 第七季',
    description: '神秘唱将戴着面具登台，用声音征服猜评团。面具之下，可能是你意想不到的超级巨星！',
    category: 'music',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20masked%20singer%20show%20stage%20singer%20wearing%20elaborate%20mysterious%20mask%20and%20costume%20singing%20on%20colorful%20stage%20mysterious%20atmosphere%20dramatic%20spotlight%20professional%20photography&width=800&height=450&seq=show-12&orientation=landscape',
    date: '2026-06-25',
    views: '2.0亿',
    duration: '80分钟',
    tags: ['音乐', '竞猜', '神秘'],
    rating: 9.0,
    fullContent: '<h2>节目简介</h2><p>《蒙面唱将猜猜猜》是一档音乐悬疑竞猜类真人秀。第七季延续了"蒙面"的神秘感，歌手们戴着精心设计的面具登台献唱，猜评团和观众需要根据声音和线索猜测歌手身份。</p><h2>节目亮点</h2><p>本季面具设计更加精美华丽，舞台效果全面升级。猜评团阵容也更加强大，增加了更多互动环节和推理线索。</p><h2>播出信息</h2><p>每周日晚21:10江苏卫视播出，网络平台同步更新。</p>',
    host: '大张伟',
    guests: ['沈南', 'ella', '李克勤', '杨丞琳'],
    episodes: 12,
    platform: '江苏卫视+网络平台',
    updateDay: '每周日',
  },
  {
    id: 'show-13',
    title: '爸爸当家 第五季',
    description: '萌娃与爸爸的温馨日常，亲子互动暖化人心。看明星爸爸们如何带娃，有笑有泪有爱的家庭时光。',
    category: 'lifestyle',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20parenting%20variety%20show%20father%20and%20cute%20child%20playing%20in%20sunny%20park%20green%20grass%20warm%20sunlight%20heartwarming%20moment%20casual%20clothing%20professional%20photography%20soft%20natural%20light&width=800&height=450&seq=show-13&orientation=landscape',
    date: '2026-06-22',
    views: '1.6亿',
    duration: '60分钟',
    tags: ['亲子', '生活', '温馨'],
    rating: 9.3,
    fullContent: '<h2>节目简介</h2><p>《爸爸当家》是一档亲子互动真人秀。第五季邀请了多位明星爸爸和他们的萌娃一起参与，记录爸爸们独立带娃的全过程。</p><h2>节目亮点</h2><p>本季特别设置了"爸爸大挑战"环节，让爸爸们在各种意想不到的情况下展现育儿智慧。孩子们天真烂漫的表现和爸爸们手忙脚乱的可爱模样，让节目充满了温馨与欢乐。</p><h2>播出信息</h2><p>每周六上午10:00更新，每期约60分钟。全家适宜观看。</p>',
    host: '李锐',
    guests: ['吴尊', '刘畊宏', '张亮'],
    episodes: 10,
    platform: '网络平台首播',
    updateDay: '每周六',
  },
  {
    id: 'show-14',
    title: '全员加速中 2026',
    description: '大型实景科幻竞技真人秀！明星们在城市中躲避猎人追捕，完成高难度任务，谁能坚持到最后？',
    category: 'competition',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20action%20chase%20variety%20show%20celebrities%20running%20through%20modern%20shopping%20mall%20being%20chased%20by%20hunters%20in%20black%20suits%20dynamic%20action%20scene%20dramatic%20lighting%20professional%20photography&width=800&height=450&seq=show-14&orientation=landscape',
    date: '2026-06-18',
    views: '1.9亿',
    duration: '85分钟',
    tags: ['竞技', '科幻', '刺激'],
    rating: 9.2,
    fullContent: '<h2>节目简介</h2><p>《全员加速中》是一档大型创意实景科幻竞技真人秀。2026全新赛季，明星加速队员将在真实城市场景中躲避"猎人"的追捕，完成各种高难度任务。</p><h2>节目亮点</h2><p>本季场景更加宏大，涵盖大型商场、主题乐园、历史文化街区等多种实景。猎人阵容升级，加入了更多高科技追踪手段，让任务更加紧张刺激。</p><h2>播出信息</h2><p>每周六晚20:10湖南卫视播出，网络平台同步更新。</p>',
    host: '杜海涛',
    guests: ['王一博', '杨幂', '黄明昊', '王俊凯'],
    episodes: 12,
    platform: '湖南卫视+网络平台',
    updateDay: '每周六',
  },
  {
    id: 'show-15',
    title: '吐槽大会 第七季',
    description: '笑果文化金牌IP回归！明星嘉宾互相吐槽，毒舌幽默火力全开，用喜剧化解一切，让你笑出腹肌。',
    category: 'talkshow',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20roast%20comedy%20show%20stage%20comedian%20holding%20microphone%20making%20audience%20laugh%20modern%20studio%20with%20LED%20screens%20bright%20stage%20lighting%20professional%20photography%20entertaining&width=800&height=450&seq=show-15&orientation=landscape',
    date: '2026-06-15',
    views: '1.7亿',
    duration: '65分钟',
    tags: ['脱口秀', '吐槽', '搞笑'],
    rating: 8.8,
    fullContent: '<h2>节目简介</h2><p>《吐槽大会》是一档喜剧脱口秀节目。第七季延续了"吐槽是门手艺"的核心理念，每期邀请一位主咖和多位吐槽嘉宾，用幽默风趣的方式互相吐槽。</p><h2>节目亮点</h2><p>本季吐槽嘉宾阵容更加多元，涵盖影视、音乐、体育、文化等各个领域。吐槽内容更加犀利但不失友善，在笑声中传递积极向上的价值观。</p><h2>播出信息</h2><p>每周日晚20:00更新，每期约65分钟。</p>',
    host: '张绍刚',
    guests: ['李诞', '池子', '王建国', '庞博'],
    episodes: 10,
    platform: '网络平台首播',
    updateDay: '每周日',
  },
  {
    id: 'show-16',
    title: '中餐厅 第九季',
    description: '黄晓明带队海外开餐厅！在异国他乡传播中华美食文化，经营挑战与温暖故事交织的治愈之旅。',
    category: 'lifestyle',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20restaurant%20variety%20show%20celebrities%20cooking%20and%20serving%20in%20a%20beautiful%20Chinese%20style%20restaurant%20warm%20interior%20cozy%20atmosphere%20professional%20photography%20appetizing%20food&width=800&height=450&seq=show-16&orientation=landscape',
    date: '2026-06-12',
    views: '2.2亿',
    duration: '80分钟',
    tags: ['美食', '经营', '文化'],
    rating: 9.1,
    fullContent: '<h2>节目简介</h2><p>《中餐厅》是一档青春合伙人经营体验节目。第九季黄晓明带领新一季合伙人在法国巴黎开设中餐厅，向世界展示中华美食的魅力。</p><h2>节目亮点</h2><p>本季选址浪漫之都巴黎，餐厅设计融合了中国传统元素与法式优雅。合伙人需要面对语言障碍、文化差异和经营压力，用美食搭建文化交流的桥梁。</p><h2>播出信息</h2><p>每周五晚22:00湖南卫视播出，网络平台同步更新。</p>',
    host: '黄晓明',
    guests: ['王俊凯', '杨紫', '林述巍'],
    episodes: 12,
    platform: '湖南卫视+网络平台',
    updateDay: '每周五',
  },
  {
    id: 'show-17',
    title: '乘风破浪的姐姐 第五季',
    description: '三十位30+女艺人重新出发，用实力打破年龄界限。唱跳舞台燃炸全场，姐姐们的逆袭之路惊艳所有人。',
    category: 'talent',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20female%20artist%20survival%20show%20stage%20elegant%20mature%20women%20in%20glamorous%20performance%20outfits%20dancing%20on%20grand%20stage%20dramatic%20lighting%20confident%20expressions%20professional%20photography&width=800&height=450&seq=show-17&orientation=landscape',
    date: '2026-06-08',
    views: '3.8亿',
    duration: '100分钟',
    tags: ['选秀', '女性', '热门'],
    rating: 9.5,
    fullContent: '<h2>节目简介</h2><p>《乘风破浪的姐姐》是芒果TV推出的女团成长综艺节目。第五季邀请了三十位年龄30+的女艺人，她们将放下过去的成就，从零开始角逐最终的成团名额。</p><h2>节目亮点</h2><p>本季舞台制作全面升级，邀请了国际顶级编舞师和音乐制作人。姐姐们用实力证明了年龄只是数字，每一个舞台都是一次惊艳的蜕变。</p><h2>播出信息</h2><p>每周五、周六中午12:00更新，每期约100分钟。</p>',
    host: '黄晓明',
    guests: ['宁静', '那英', '张雨绮'],
    episodes: 12,
    platform: '网络平台独家',
    updateDay: '每周五、六',
  },
  {
    id: 'show-18',
    title: '乐队的夏天 第四季',
    description: '中国最燃乐队现场归来！新老乐队同台竞技，用最纯粹的音乐和最炸裂的现场，点燃摇滚之魂。',
    category: 'music',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20band%20music%20competition%20show%20rock%20band%20performing%20on%20stage%20with%20instruments%20energetic%20atmosphere%20colorful%20stage%20lighting%20crowd%20cheering%20professional%20photography%20dynamic&width=800&height=450&seq=show-18&orientation=landscape',
    date: '2026-06-05',
    views: '1.4亿',
    duration: '90分钟',
    tags: ['音乐', '乐队', '摇滚'],
    rating: 9.4,
    fullContent: '<h2>节目简介</h2><p>《乐队的夏天》是一档原创音乐综艺节目。第四季汇聚了来自全国各地的31支乐队，涵盖摇滚、民谣、电子、朋克等多种风格，用原创音乐展现中国乐队的才华。</p><h2>节目亮点</h2><p>本季超级乐迷阵容升级，邀请了中国摇滚乐坛的传奇人物担任嘉宾。赛制上增加了合作创作环节，不同风格的乐队将碰撞出意想不到的火花。</p><h2>播出信息</h2><p>每周六晚20:00更新，每期约90分钟。提供杜比全景声版本。</p>',
    host: '马东',
    guests: ['张亚东', '大张伟', '周迅', '彭磊'],
    episodes: 12,
    platform: '网络平台首播',
    updateDay: '每周六',
  },
  {
    id: 'show-19',
    title: '萌探探探案 第四季',
    description: '明星沉浸式剧本杀来袭！孙红雷、那英领衔萌探家族，在精心设计的案件中各显神通，谁是卧底？',
    category: 'competition',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20mystery%20detective%20variety%20show%20celebrities%20in%20period%20costumes%20investigating%20in%20a%20mysterious%20mansion%20vintage%20interior%20dramatic%20lighting%20suspenseful%20atmosphere%20professional%20photography&width=800&height=450&seq=show-19&orientation=landscape',
    date: '2026-06-01',
    views: '1.8亿',
    duration: '75分钟',
    tags: ['推理', '剧本杀', '悬疑'],
    rating: 8.9,
    fullContent: '<h2>节目简介</h2><p>《萌探探探案》是一档沉浸式推理真人秀。第四季萌探家族在全新升级的剧本杀场景中，通过推理和演技找出隐藏的卧底。</p><h2>节目亮点</h2><p>本季案件设计更加精巧复杂，场景布置更加宏大逼真。每期设定不同的时代背景和故事主题，嘉宾们需要完全沉浸角色，在错综复杂的线索中寻找真相。</p><h2>播出信息</h2><p>每周五晚20:00更新，每期约75分钟。</p>',
    host: '吴彤',
    guests: ['孙红雷', '那英', '杨迪', '沙溢', '杨紫'],
    episodes: 12,
    platform: '网络平台首播',
    updateDay: '每周五',
  },
  {
    id: 'show-20',
    title: '春日迟迟再出发 第三季',
    description: '治愈系旅行真人秀！一群带着故事的年轻人踏上心灵疗愈之旅，在美丽的风景中寻找生活的新方向。',
    category: 'reality',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20healing%20travel%20variety%20show%20young%20people%20walking%20on%20beach%20at%20sunset%20peaceful%20ocean%20view%20warm%20golden%20light%20thoughtful%20expressions%20professional%20photography%20cinematic%20composition&width=800&height=450&seq=show-20&orientation=landscape',
    date: '2026-05-28',
    views: '0.9亿',
    duration: '55分钟',
    tags: ['旅行', '治愈', '情感'],
    rating: 9.0,
    fullContent: '<h2>节目简介</h2><p>《春日迟迟再出发》是一档情感治愈旅行真人秀。第三季邀请了一群正在经历人生转折的年轻人，在专业心理导师的陪伴下踏上一段自我探索之旅。</p><h2>节目亮点</h2><p>本季旅行目的地选择了云南大理和丽江，在苍山洱海的怀抱中，嘉宾们敞开心扉，分享各自的故事与困惑。温暖的旅行氛围和真诚的情感交流，让节目成为一剂治愈心灵的良药。</p><h2>播出信息</h2><p>每周三晚20:00更新，每期约55分钟。</p>',
    host: '大左',
    guests: ['沈奕斐', '李松蔚'],
    episodes: 8,
    platform: '网络平台首播',
    updateDay: '每周三',
  },
  {
    id: 'show-21',
    title: '闪光的乐队 第三季',
    description: '顶尖音乐人跨界组乐队！不同风格的音乐人碰撞融合，用音乐打破边界，创造属于这个时代的闪光舞台。',
    category: 'music',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20music%20collaboration%20variety%20show%20musicians%20from%20different%20genres%20jamming%20together%20in%20a%20recording%20studio%20warm%20lighting%20creative%20atmosphere%20professional%20photography%20instruments&width=800&height=450&seq=show-21&orientation=landscape',
    date: '2026-05-25',
    views: '1.1亿',
    duration: '85分钟',
    tags: ['音乐', '合作', '创新'],
    rating: 9.2,
    fullContent: '<h2>节目简介</h2><p>《闪光的乐队》是一档音乐人组队竞演综艺。第三季邀请了流行、摇滚、民谣、电子等不同领域的音乐人，他们将被随机组成乐队，在限定时间内创作并表演原创作品。</p><h2>节目亮点</h2><p>本季强调音乐的跨界融合，不同风格的音乐人被迫走出舒适区，在碰撞中寻找共鸣。许多意想不到的组合产生了令人惊艳的音乐化学反应。</p><h2>播出信息</h2><p>每周六晚20:30更新，每期约85分钟。</p>',
    host: '华少',
    guests: ['张亚东', '萧敬腾', '周延'],
    episodes: 10,
    platform: '浙江卫视+网络平台',
    updateDay: '每周六',
  },
  {
    id: 'show-22',
    title: '少年之名 2026',
    description: '百位少年为梦想集结！在严苛的训练和残酷的竞争中，看少年们如何破茧成蝶，用实力赢得观众的认可。',
    category: 'talent',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20young%20male%20idol%20survival%20show%20large%20group%20of%20teenage%20boys%20in%20matching%20school%20uniform%20style%20outfits%20performing%20on%20stage%20youthful%20energy%20bright%20lighting%20professional%20photography&width=800&height=450&seq=show-22&orientation=landscape',
    date: '2026-05-20',
    views: '2.4亿',
    duration: '110分钟',
    tags: ['选秀', '少年', '偶像'],
    rating: 9.3,
    fullContent: '<h2>节目简介</h2><p>《少年之名》是优酷出品的少年青春逐梦同行成长综艺。2026赛季百位少年聚集在一起，通过三个月的封闭训练和多轮竞演，争夺最终的出道机会。</p><h2>节目亮点</h2><p>本季训练体系全面升级，邀请国际顶级编舞师和声乐指导。少年们在节目中不仅展示才艺，更展现了成长中的坚持、友谊与蜕变。</p><h2>播出信息</h2><p>每周四、周日晚19:00更新，每期约110分钟。</p>',
    host: '张艺兴',
    guests: ['郭敬明', '胡彦斌', '程潇', '韩宇'],
    episodes: 10,
    platform: '网络平台独家',
    updateDay: '每周四、日',
  },
  {
    id: 'show-23',
    title: '明星大侦探 第十季',
    description: '何炅、撒贝宁双北组合再度联手！全新案件、全新场景、全新玩法，在推理中找到真相，在欢笑中感悟人生。',
    category: 'competition',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20detective%20mystery%20variety%20show%20celebrities%20in%20detective%20costumes%20investigating%20crime%20scene%20in%20luxurious%20room%20vintage%20decor%20dramatic%20suspenseful%20lighting%20professional%20photography&width=800&height=450&seq=show-23&orientation=landscape',
    date: '2026-05-15',
    views: '3.0亿',
    duration: '95分钟',
    tags: ['推理', '悬疑', '热门'],
    rating: 9.6,
    fullContent: '<h2>节目简介</h2><p>《明星大侦探》是中国首档明星推理综艺秀。第十季"双北组合"何炅与撒贝宁强势回归，带领全新嘉宾阵容在精心设计的案件中斗智斗勇。</p><h2>节目亮点</h2><p>本季案件全面升级，场景制作达到了电影级别。每个案件背后都隐藏着深刻的社会议题，在推理悬疑的同时传递正能量。新加入的AI互动元素让推理过程更加丰富有趣。</p><h2>播出信息</h2><p>每周五、周六中午12:00更新，每期约95分钟。VIP可观看案件衍生花絮。</p>',
    host: '何炅',
    guests: ['撒贝宁', '白敬亭', '刘昊然', '张若昀', '王鸥'],
    episodes: 12,
    platform: '网络平台独家',
    updateDay: '每周五、六',
  },
  {
    id: 'show-24',
    title: '非正式会谈 第九季',
    description: '各国青年代表齐聚圆桌，用多元视角解读全球热点。跨文化交流碰撞出智慧火花，有趣又有料。',
    category: 'talkshow',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20international%20talk%20show%20round%20table%20discussion%20diverse%20young%20people%20from%20different%20countries%20sitting%20around%20table%20modern%20studio%20warm%20lighting%20friendly%20atmosphere%20professional%20photography&width=800&height=450&seq=show-24&orientation=landscape',
    date: '2026-05-10',
    views: '0.8亿',
    duration: '50分钟',
    tags: ['脱口秀', '文化', '国际'],
    rating: 9.3,
    fullContent: '<h2>节目简介</h2><p>《非正式会谈》是一档全球文化相对论节目。第九季邀请了来自15个国家的青年代表，围绕当下热点话题展开跨文化讨论。</p><h2>节目亮点</h2><p>本季话题更加贴近年轻观众的关注点，从AI发展到气候变化，从教育理念到婚恋观念，各国代表用自己国家的文化视角带来独特的见解和思考。</p><h2>播出信息</h2><p>每周五晚21:30更新，每期约50分钟。</p>',
    host: '大左',
    guests: ['杨迪', '陈铭', '陈超'],
    episodes: 12,
    platform: '网络平台首播',
    updateDay: '每周五',
  },
];

export function getShowsByCategory(slug: string): Show[] {
  if (slug === 'all') return shows;
  return shows.filter((s) => s.category === slug);
}

export function getShowById(id: string): Show | undefined {
  return shows.find((s) => s.id === id);
}

export function getRelatedShows(currentId: string, category: string, limit: number = 4): Show[] {
  return shows.filter((s) => s.id !== currentId && s.category === category).slice(0, limit);
}

export function getHotShows(limit: number = 8): Show[] {
  return [...shows].sort((a, b) => b.rating - a.rating).slice(0, limit);
}

export function getLatestShows(limit: number = 8): Show[] {
  return [...shows].sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime()).slice(0, limit);
}